import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { tokenRequest, urlConfig } from "../../../config";
import { Link } from "react-router-dom";
import { NavBox } from "./navBar.styles";
import {
  GlobeIcon,
  LogoutIcon,
  MenuIcon,
  ProfileIcon,
} from "../../../assets/svg";
import { decodeToken } from "../../../utils/helper";
import { images } from "../../../constant";

export const NavBar = () => {
  const { instance, accounts } = useMsal();
  const [userDetails, setUserDetails] = React.useState<any>(null);

  React.useEffect(() => {
    if (accounts && accounts.length >= 1) {
      acquireToken(accounts[0]);
    }
  }, [accounts]);

  const closeWindow = async () => {
    localStorage.clear();
    window.close();
    // const logoutRequest = {
    //   accounts: instance.getAccountByHomeId(accounts[0].homeAccountId),
    //   postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    // };

    // Handle msal loogout
    // instance.logoutRedirect(logoutRequest);
  };

  const acquireToken = async (account: any) => {
    if (!account) {
      throw Error(
        "No active account! Verify a user has been signed in and setActiveAccount has been called."
      );
    }

    const loginMode = localStorage.getItem("mode") ?? "";

    try {
      const response = await instance.acquireTokenSilent({
        ...tokenRequest,
        account: account,
        authority: loginMode === "google" ? urlConfig.B2C_GOOGLE_AUTHORITY : "",
      } as any);

      if (response) {
        const decodedToken = decodeToken(response.idToken);
        setUserDetails(decodedToken);
      }
    } catch (err) {}
  };

  const isLoggedIn: boolean = accounts && accounts.length >= 1 ? true : false;

  return (
    <>
      <NavBox className="bg-white z-[5000]">
        <div className="container-fluid px-lg-4">
          <div className="d-flex justify-content-between align-items-center !py-5">
            <Link to="#" className="d-inline-flex flex-column logo-link">
              <img className="" src={images.PaycurraLogo} alt="Paycurra logo" />
              {isLoggedIn && <small className="ms-auto">Checkout</small>}
            </Link>

            <IconButton className="!inline-flex md:!hidden">
              <MenuIcon />
            </IconButton>

            <div className="hidden md:flex md:items-center !gap-2">
              <Link to="#" className="me-2 underline">
                Contact Support
              </Link>

              {isLoggedIn && (
                <div className="greet">Hello, {userDetails?.given_name}</div>
              )}

              {isLoggedIn && (
                <div className="d-inline-flex gap-3 align-items-center">
                  <div className="profile-icon">
                    <ProfileIcon />
                  </div>

                  <GlobeIcon />

                  <IconButton onClick={closeWindow}>
                    <Tooltip title="Logout">
                      <LogoutIcon />
                    </Tooltip>
                  </IconButton>
                </div>
              )}
            </div>
          </div>
        </div>
      </NavBox>
    </>
  );
};
